import { render, staticRenderFns } from "./HotelDetailsBody.vue?vue&type=template&id=1f6707dc&"
import script from "./HotelDetailsBody.vue?vue&type=script&lang=js&"
export * from "./HotelDetailsBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports